// extracted by mini-css-extract-plugin
module.exports = {"ImageStaticAds":"ImageStaticAds_ImageStaticAds__vXgbt"};